/* eslint-disable @typescript-eslint/no-explicit-any */

export default {
  /**
   * Returns the queryParameters as object
   * ignores dupplicate keys, by only saving the later
   *
   * e.g. ?hello=world&hello=there
   * will result in { hello: 'there' }
   */
  getQueryParams() {
    const uri = window.location.href.split('?');
    const queryParams = {} as any;
    if (uri.length === 2) {
      const queryParamList = uri[1].split('&');

      queryParamList.forEach((queryParam) => {
        const [key, value] = queryParam.split('=');
        if (key) {
          queryParams[key] = decodeURIComponent(value);
        }
      });
    }
    return queryParams;
  },

  /**
   * Overwrites the queryParams with the given object
   */
  setQueryParams(fullObj: Record<string, any>) {
    const obj: Record<string, any> = {};
    // remove all <undefined | null | ""> values from the object
    for (const [key, value] of Object.entries(fullObj)) {
      if (!value) {
        continue;
      }
      obj[key] = value;
    }

    const uri = window.location.href.split('?');

    const queryString = Object.keys(obj)
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
      .join('&');
    const url = `${uri[0]}?${queryString}`;

    if (window.history.replaceState) {
      // record changes to the query params in analytics. The urls send to
      // analytics are relative thus here we strip away the origin
      const urlObj = new URL(url);
      const analyticsUrl = `${urlObj.pathname}${urlObj.search}`;
      window.history.replaceState(null, '', analyticsUrl);
      try {
        ga('set', 'page', analyticsUrl);
        ga('send', 'pageview');
      } catch (e) {
        console.log('Analytics error');
      }
    }
  },

  /**
   * Adds a new object to the existing queryParams
   */
  addQueryParams(obj: Record<string, any>) {
    const queryParams = Object.assign(this.getQueryParams(), obj);
    this.setQueryParams(queryParams);
  },

  /**
   * Removes a key from the queryParams
   */
  removeQueryParam(key: string) {
    const queryParams = this.getQueryParams();
    delete queryParams[key];
    this.setQueryParams(queryParams);
  },

};
